module.exports = __webpack_public_path__ + "static/media/crocodile(15).bc1c34cc.PNG";